
import { utils } from "Utils/Utils";
import $ from "jquery";

var vConnectReactPayload = {};
///Vagaro Connect JS 
(function () {
    //Start - Added by Nayan Satani on 29/02/2024
    window._vagaroConnect = {
        model: {
            isChatIframeLoaded: false,
            vagaroConnectPath: "",
            isAdmin: true,
            vagaroConnectTextMessagingPlanIframe: "/ShopOwner/VagaroConnectTextMessagingPlanIframe.aspx?isvc=true"
        },
        controls: {
            lnkForChat: "#lnkForChat",
            chatFrame: "#chatFrame",
            chatWindow: "#chatWindow",
            vgCalendarPath: "/merchants/calendar",
            vcChatFrameDiv: "#chatFrame",
            SetOpenChatStatusToken: "SetVagaroConnectChat",
            ifrmTextMarketingPlans: "#ifrmTextMarketingPlans"
        },
        cssClasses: {
            vcChatFullPage: "ifreamVC",
            //vcChatMidSize: "ifreamVC ifream-rightSide",
            vcChatSmallSize: "ifream-rightSide ifream-smallscreen",
            vcChatCollapsed: "ifreamVC ifream-rightSide ifream-smallscreen ifream-minimize",
        },
        ApiURLEnum: {
            GetVagaroConnectChat: "GetVagaroConnectChat",
            SetVagaroConnectChat: "SetVagaroConnectChat"
        },
        ChatWindowEnum: {
            Closed: 0,
            FullSize: 1,
            MidSize: 2,
            Minimize: 3
        },
        AjaxPostCall: function (Token, RequestData, CallBack, Error, isAsync, isNewAPICall) {
            var vgAjaxCAll = new vagaro.ajax();

            if (typeof (isNewAPICall) != "undefined" && isNewAPICall != null && isNewAPICall == false) {
                vgAjaxCAll.datamodel.Token = Token;
                vgAjaxCAll.datamodel.IsNewVagaroAPI = isNewAPICall;
            }
            else {
                vgAjaxCAll.datamodel.Token = ((typeof VagaroCoreApiUrl != "undefined" && VagaroCoreApiUrl != null && VagaroCoreApiUrl != "") ? VagaroCoreApiUrl : "") + Token;
                vgAjaxCAll.datamodel.IsNewVagaroAPI = true;
            }

            vgAjaxCAll.datamodel.data = RequestData;
            // Following parameter passed from Calendar Service In Progress Status
            if (typeof (isAsync) != "undefined" && isAsync != null) {
                vgAjaxCAll.datamodel.async = isAsync;
            }
            vgAjaxCAll.datamodel.Error = Error;
            vgAjaxCAll.datamodel.callback = CallBack;
            vgAjaxCAll.Post();
        },
        CallFailed: function (resp) {

        },
        GetVcOpenStatus: function (currentUrl) {
            var data = {};
            data.currentPageUrl = currentUrl;
            _vagaroConnect.AjaxPostCall(_vagaroConnect.ApiURLEnum.GetVagaroConnectChat, data, _vagaroConnect.Success_GetVagaroConnectChat, _vagaroConnect.CallFailed, false, false);
        },
        Success_GetVagaroConnectChat: function (objResult) {
            var currentUrl = window.location.host + window.location.pathname;
            if (objResult != null) {
                var result = objResult;
                if (result != null) {
                    //console.log("VagaroConnect Chat Open Status :" + result);
                    if (result.CurrentPageUrl === currentUrl && result.Status == 1) {
                        _vagaroConnect.ShowChatFrame(0);  //1 means full screen page
                        window.vcReactStatus = 0;
                    }
                    else if (result.Status == 2) {
                        // need to show mid size chat if page refreshed or redirected
                        _vagaroConnect.ShowChatFrame(2); //2 means mid size
                        $(_vagaroConnect.controls.chatFrame).addClass("ifream-rightSide");
                        $(_vagaroConnect.controls.chatFrame).addClass("ifream-smallscreen");
                        window.vcReactStatus = 2;
                    }
                    else if (result.Status == 3) {
                        // need to show small size chat if page refreshed or redirected
                        _vagaroConnect.ShowChatFrame(3); //3 means mid size
                        $(_vagaroConnect.controls.chatFrame).addClass("ifream-rightSide");
                        $(_vagaroConnect.controls.chatFrame).addClass("ifream-smallscreen");
                        $(_vagaroConnect.controls.chatFrame).addClass("ifream-minimize");
                        window.vcReactStatus = 3;
                    }
                    else {
                        // No need to show chat - status 0 also no need to show
                        _vagaroConnect.ShowChatFrame(0);
                        window.vcReactStatus = 0;
                    }
                }
                else {
                    console.log("Something went wrong. VagaroConnect Chat Open Status");
                }
            }
        },
        SetVcOpenStatus: function (openStatus, currentUrl) {
            var data = {};
            //var currentUrl = window.location.host + window.location.pathname;
            data.currentPageUrl = currentUrl;
            data.vcStatus = openStatus; //1 means full size open
            _vagaroConnect.AjaxPostCall(_vagaroConnect.ApiURLEnum.SetVagaroConnectChat, data, _vagaroConnect.Success_SetVcOpenStatus, _vagaroConnect.CallFailed, false, false);
        },
        Success_SetVcOpenStatus: function (response) {
            console.log("vc app opened session");
        },
        CustomerWithoutLoginData: function (Data) {
            var customeData = Data[0];
            vConnectReactPayload.ReactBusinessId = customeData.businessID;
            vConnectReactPayload.ReactV2BId = customeData.encBID;
            vConnectReactPayload.ReactShopOwnerId = customeData.shopOwnerID;
            vConnectReactPayload.merchantId = customeData.encBID;
            vConnectReactPayload.ReactV2UId = customeData.encUserID;
            vConnectReactPayload.ReactUId = customeData.encUserID;
            vConnectReactPayload.ReactUserID = customeData.encUserID;
            vConnectReactPayload.ReactFirstName = customeData.userFirstName;
            vConnectReactPayload.ReactLastName = customeData.userLastName;
            vConnectReactPayload.ReactProfileImage = customeData.userPhoto;
            vConnectReactPayload.ReactCdnUrl = customeData.userCDNUrl;
            vConnectReactPayload.ViewCustomer = "true";
            vConnectReactPayload.ModifyCustomer = "true";
            vConnectReactPayload.ViewEmployee = "true";
            vConnectReactPayload.ModifyEmployee = "true";
            vConnectReactPayload.ManageCustomerModifyRights = "true";
            vConnectReactPayload.ManageCustomerViewRights = "true";
            vConnectReactPayload.ManageEmployeeModifyRights = "true";
            vConnectReactPayload.ManageEmployeeViewRights = "true";
            vConnectReactPayload.ManageOtherPeopleCalendarViewRights = "true";
            vConnectReactPayload.ManageOtherPeopleCalendarModifyRights = "true";
            vConnectReactPayload.LoginUserIdHash = customeData.encUserIDHash;
            vConnectReactPayload.isCustomerChat = true;
            vConnectReactPayload.VagaroCoreAPIURLConnect = customeData.vagaroConnectAPIURL;
            vConnectReactPayload.VagaroCoreAPIURLV2 = customeData.connectVagaroCoreAPIURLV2;
            vConnectReactPayload.VagaroConnectSignalRURL = customeData.vagaroConnectAPIURL;
            vConnectReactPayload.vagaroConnectWebAppURL = customeData.vagaroConnectWebAppURL;
            vConnectReactPayload.CountryID = customeData.countryID;
            vConnectReactPayload.encStaticMerchantid = customeData.staticEncBID;

        },
        CustomerData: function (Data, SiteData) {
            if (Data !== undefined && Data !== null && Data !== "") {
                var nameArray = Data.UName.split(" ");
                if (Data.UImage !== undefined && Data.UImage !== null && Data.UImage !== "") {
                    var parts = Data.UImage.split("/");
                    var userCDNUrl = parts[0] + "//" + parts[2];
                    var ImageSize = parts[3];
                    var userPhoto = parts[4];
                }
                const BusinessData = utils.MultiLocationData(SiteData, SiteData.bidHash);
                let FlagshipBusinessDetail = null;
                if (BusinessData.isSyncTextPlan) {
                    const FlagshipBusiness = utils.FlagshipBusinessData(SiteData, BusinessData.snyBusinessID);
                    if(FlagshipBusiness !== undefined && FlagshipBusiness !== null && FlagshipBusiness !==""){
                        FlagshipBusinessDetail = {
                            encStaticMerchantid: FlagshipBusiness.staticEncBID,
                            isHasSharedCustomer: true,
                            isSyncTextPlan: FlagshipBusiness.isSyncTextPlan,
                            groupId: FlagshipBusiness.group,
                            reactShopOwnerId: FlagshipBusiness.shopOwnerID,
                            reactV2BId: FlagshipBusiness.encBID,
                            reactBusinessId: FlagshipBusiness.businessID,
                        };
                    }                   
                }
                vConnectReactPayload.FlagshipBusinessDetail = FlagshipBusinessDetail;
                vConnectReactPayload.ReactBusinessName = BusinessData.businessName;
                vConnectReactPayload.ReactBusinessId = BusinessData.businessID;
                vConnectReactPayload.ReactV2BId = BusinessData.encBID;
                vConnectReactPayload.merchantId = BusinessData.encBID;
                vConnectReactPayload.ReactFirstName = nameArray[0];
                vConnectReactPayload.ReactLastName = nameArray[1];
                vConnectReactPayload.ReactV2UId = Data.cEncUid;
                vConnectReactPayload.ReactUId = Data.cEncUid;
                vConnectReactPayload.ReactUserID = Data.cEncUid;
                vConnectReactPayload.LoginUserIdHash = Data.EncUidHash;
                vConnectReactPayload.ReactProfileImage = userPhoto === undefined || userPhoto === null || userPhoto === "" ? "" : userPhoto;
                vConnectReactPayload.ReactCdnUrl = userCDNUrl;
                vConnectReactPayload.ReactBusinessImage = BusinessData.businessImage === undefined || BusinessData.businessImage === null || BusinessData.businessImage === "" ? "" : BusinessData.cdnUrl + "Original/" + BusinessData.businessImage;
                vConnectReactPayload.encStaticMerchantid = BusinessData.staticEncBID;
                vConnectReactPayload.encStaticUserid = Data.csEncUid === undefined || Data.csEncUid === null || Data.csEncUid === "" ? "" : Data.csEncUid;
            }
        },
        ShowChatFrame: function (status) {
            //$(document).on("click", _vagaroConnect.controls.lnkForChat, function (e) {
            // Check if the current path is '/merchants/calendar'
            var defaultSize = 0;
            var isFromConnectApp = false;
            var isIOSMobile = false;
            var isAndroidIOSMobile = false;
            var QueryStringValue = window.document.URL ? window.document.URL : "";


            if (window.parent.location.pathname === _vagaroConnect.controls.vgCalendarPath) {
                window.top.$('body').css("overflow", "hidden");
                console.log('calender page');
            }
            if ($(_vagaroConnect.controls.chatFrame).length > 0) {  // Check if #chatFrame exists                
                if (_vagaroConnect.model.isChatIframeLoaded) {  // Check if #chatWindow has children                */

                    VagaroConnectIframDesignObject();
                    if (window.vcReactStatus) {
                        defaultSize = status == 1 ? 0 : status;
                    }
                    if (QueryStringValue.includes("vagaroconnect?1=1") || QueryStringValue.includes("vagaroconnect?")) {
                        isFromConnectApp = true;
                    }
                    if (window.navigator.userAgent.indexOf("iPhone") > 0 && window.navigator.userAgent.indexOf("Mobile") > 0) {
                        defaultSize = 1;
                        isIOSMobile = true;
                    }
                    if ((window.navigator.userAgent.indexOf("iPhone") > 0 && window.navigator.userAgent.indexOf("Mobile") > 0) || (window.navigator.userAgent.indexOf("Android") > 0 && window.navigator.userAgent.indexOf("Mobile") > 0)) {
                        defaultSize = 1;
                        isAndroidIOSMobile = true;
                    }

                    var oFrom = navigator.userAgent;
                    var devices = ""

                    var OpenedFrom = {
                        iphone: oFrom.match(/(iPhone|iPod)/),
                        blackberry: oFrom.match(/BlackBerry/),
                        kindle: oFrom.match(/Silk/),
                        android: oFrom.match(/Android/),
                        windows: oFrom.match(/Windows/),
                        ipad: oFrom.match(/iPad/),
                        mac: oFrom.match(/Mac/),
                        iosDevice: oFrom.match(/iPhone|iPod|Mac/)
                    };
                    if (OpenedFrom.windows)
                        devices = devices + " Windows Phone";
                    if (OpenedFrom.iphone)
                        devices = devices + " iPhone";
                    if (OpenedFrom.android)
                        devices = devices + " Android";
                    if (OpenedFrom.blackberry)
                        devices = devices + " Blackberry";
                    if (OpenedFrom.ipad)
                        devices = devices + " iPad";
                    if (OpenedFrom.kindle)
                        devices = devices + " kindle";
                    if (OpenedFrom.mac) {
                        let isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
                        if (isIpad) {
                            devices = devices + " iPad";
                        }
                        else {
                            devices = devices + " Mac";
                        }
                    }

                    if (OpenedFrom.iosDevice)
                        devices = devices + " iosDevice";
                    $('body').addClass('scrollhidden');
                    vConnectReactPayload.Device = devices;
                    vConnectReactPayload.defaultSize = 2;
                    vConnectReactPayload.isFromConnectApp = isFromConnectApp;
                    vConnectReactPayload.isIOSMobile = isIOSMobile;
                    vConnectReactPayload.isAndroidIOSMobile = isAndroidIOSMobile;
                    vConnectReactPayload.intialState = status;
                    //Send Initla Data
                    _postMessage('{"eventType": "GetIntitalData", "payload" : ' + JSON.stringify(vConnectReactPayload) + '}');

                    //Get Unread Counnt
                    //_postMessage('{"eventType": "UpdateUnReadCount", "payload" : ' + status + '}');
                    //_vagaroConnect.SetVcOpenStatus(status, window.location.host + window.location.pathname);  //1 means full size page
                    $('a[id="lnkForChat"]').addClass("activefirst");

                    if (parseInt(status) > 0) {
                        $(_vagaroConnect.controls.chatFrame).show();
                        // $(_vagaroConnect.controls.chatFrame).addClass('ifreamVC');
                    }
                    return;
                }
                else {
                    var objectiframe = $(_vagaroConnect.controls.chatWindow);

                    objectiframe.on('load', function () {



                        if ($(this).attr('src') != "") {
                            if (vConnectReactPayload.isCustomerChat) {
                                $("#chatFrame,#chatWindow").show();
                            }
                            //_vagaroConnect.SetVcOpenStatus(status, window.location.host + window.location.pathname);  //1 means full size page
                            VagaroConnectIframDesignObject();
                            if (window.vcReactStatus) {
                                defaultSize = window.vcReactStatus == 1 ? 0 : window.vcReactStatus;
                            }

                            if (QueryStringValue.includes("vagaroconnect?1=1") || QueryStringValue.includes("vagaroconnect?")) {
                                isFromConnectApp = true;
                            }
                            if (window.navigator.userAgent.indexOf("iPhone") > 0 && window.navigator.userAgent.indexOf("Mobile") > 0) {
                                defaultSize = 1;
                                isIOSMobile = true;
                            }
                            if ((window.navigator.userAgent.indexOf("iPhone") > 0 && window.navigator.userAgent.indexOf("Mobile") > 0) || (window.navigator.userAgent.indexOf("Android") > 0 && window.navigator.userAgent.indexOf("Mobile") > 0)) {
                                defaultSize = 1;
                                isAndroidIOSMobile = true;
                            }

                            var oFrom = navigator.userAgent;
                            var devices = ""
                            $('body').addClass('scrollhidden');
                            var OpenedFrom = {
                                iphone: oFrom.match(/(iPhone|iPod)/),
                                blackberry: oFrom.match(/BlackBerry/),
                                kindle: oFrom.match(/Silk/),
                                android: oFrom.match(/Android/),
                                windows: oFrom.match(/Windows/),
                                ipad: oFrom.match(/iPad/),
                                mac: oFrom.match(/Mac/),
                                iosDevice: oFrom.match(/iPhone|iPod|Mac/)
                            };
                            if (OpenedFrom.windows)
                                devices = devices + " Windows Phone";
                            if (OpenedFrom.iphone)
                                devices = devices + " iPhone";
                            if (OpenedFrom.android)
                                devices = devices + " Android";
                            if (OpenedFrom.blackberry)
                                devices = devices + " Blackberry";
                            if (OpenedFrom.ipad)
                                devices = devices + " iPad";
                            if (OpenedFrom.kindle)
                                devices = devices + " kindle";
                            if (OpenedFrom.mac) {
                                let isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
                                if (isIpad) {
                                    devices = devices + " iPad";
                                }
                                else {
                                    devices = devices + " Mac";
                                }
                            }
                            if (OpenedFrom.iosDevice)
                                devices = devices + " iosDevice";
                            vConnectReactPayload.defaultSize = 2;
                            vConnectReactPayload.Device = devices;
                            vConnectReactPayload.defaultSize = defaultSize;
                            vConnectReactPayload.isFromConnectApp = isFromConnectApp;
                            vConnectReactPayload.isIOSMobile = isIOSMobile;
                            vConnectReactPayload.isAndroidIOSMobile = isAndroidIOSMobile;
                            vConnectReactPayload.intialState = status;
                            //Send Initla Data
                            _postMessage('{"eventType": "GetIntitalData", "payload" : ' + JSON.stringify(vConnectReactPayload) + '}');

                            if (parseInt(status) > 0) {
                                $(_vagaroConnect.controls.chatFrame).show();
                                // $(_vagaroConnect.controls.chatFrame).addClass('ifreamVC');
                            }
                            //Get Unread Counnt
                            //_postMessage('{"eventType": "UpdateUnReadCount", "payload" : ""}');
                        }
                    });

                    //if ($(_vagaroConnect.controls.chatFrame).is(':visible') === false) {
                    //    $(_vagaroConnect.controls.chatFrame).show();
                    //    var pageURL = location.protocol + "//" + location.hostname + (location.port && ":" + location.port) + _vagaroConnect.model.vagaroConnectPath;
                    //    var objiframe = $(_vagaroConnect.controls.chatWindow);
                    //    var iframedoc = objiframe[0].contentWindow;
                    //    objiframe.attr('src', pageURL);
                    //}
                }
            }
        },
        Init: function () {
            if (vConnectReactPayload.isCustomerChat) {
                _vagaroConnect.model.isAdmin = "False"
            }
            if (_vagaroConnect.model.isAdmin == "False" && !location.href.toLowerCase().includes("choosebusiness.aspx")) {
                //$(_vagaroConnect.controls.chatFrame).show();
                $(_vagaroConnect.controls.chatFrame).hide();
                //var pageURL1 = location.protocol + "//" + location.hostname + (location.port && ":" + location.port) + _vagaroConnect.model.vagaroConnectPath;
                var pageURL1 = vConnectReactPayload.vagaroConnectWebAppURL+ "?v=" + Math.random();
                var objiframe1 = $(_vagaroConnect.controls.chatWindow);
                objiframe1.attr('src', pageURL1);
                objiframe1.on('load', function () {

                    if ($(this).attr('src') == "") {
                        _vagaroConnect.model.isChatIframeLoaded = false;
                    }
                    else {
                        _vagaroConnect.model.isChatIframeLoaded = true;
                    }
                    //Send Initla Data
                    //_postMessage('{"eventType": "GetIntitalData", "payload" : ' + JSON.stringify(vConnectReactPayload) + '}');

                });

                //Hide Vagaro Connect chat icon when chooseBusiness page.
                var currentPagePath = window.location.pathname.toLowerCase();
                if (currentPagePath === '/shopowner/choosebusiness.aspx') {
                    $("#spanChat").hide();
                }

                // Full Page CLass : ifreamVC
                // Mid Size Page : ifreamVC ifream-rightSide ifream-smallscreen
                // Collapsed Page : ifreamVC ifream-rightSide ifream-smallscreen ifream-minimize
                //Check Vagaro Connect Chat Open Session
                //if (!vConnectReactPayload.isCustomerChat && window.parent.location.pathname == window.location.pathname) {
                if (!vConnectReactPayload.isCustomerChat && window.parent.location.pathname == window.location.pathname) {
                    _vagaroConnect.GetVcOpenStatus(window.location.host + window.location.pathname);
                }
                else if (vConnectReactPayload.isCustomerChat) {
                    _vagaroConnect.ShowChatFrame(2);
                }
            } else {
                $("#spanChat").hide();
            }
        },
        ShowLoadingPanel: function (cFlag) {
            if (typeof ShowLoadingPanel !== 'undefined') {
                if ($(".loader-img").length > 0) {
                    $(".loader-img").css('zIndex', '999999999');
                }
                ShowLoadingPanel(cFlag);
            } else if ($(".loaderNew").length > 0) {
                if (cFlag) {
                    $(".loaderNew").css('zIndex', '999999999');
                    $(".loaderNew").show();
                } else {
                    $(".loaderNew").hide();
                }
            } else if ($(".vagaroconnectloader").length > 0) {
                if (cFlag) {
                    $(".vagaroconnectloader").show();
                } else {
                    $(".vagaroconnectloader").hide();
                }
            } else {
                $('<div class="vagaroconnectloader loader" style="display:none;z-index:999999999;"><div class="loader-img" style="z-index:999999999;"></div></div>').appendTo('body');
                $(".vagaroconnectloader").show();
            }
        },
    }
}());

$(document).ready(function () {

    window.addEventListener('message', vagaroConnectLitener, false);


    $('#divPromotionTextMarketingPlans').on('hidden.bs.modal', function () {
        $('#divPromotionTextMarketingPlans').removeClass("show");
    });

    if (localStorage.getItem("openCustomMessage") == "true") {
        localStorage.setItem("openCustomMessage", "false");
        var connectInterval = "";
        try {
            connectInterval = setInterval(function () {
                if (typeof vConnectReactPayload != "undefined") {
                    clearInterval(connectInterval);
                    _siteBuilderDetail.OpenVagaroConnectChat();

                }
            }, 50)
        } catch (e) {
            clearInterval(connectInterval);
        }
    }

});

function vagaroConnectLitener(e) {
    if (e != null && e != 'undefined' && e.data != null && e.data != 'undefined') {
        if (isJsonString(e.data || e.originalEvent.data)) {
            var m = JSON.parse(e.data || e.originalEvent.data);
            switch (m.eventType) {
                case 'iFrameReset':
                    var iFrameResetRequest = JSON.parse(m.Data);
                    ExpandMinimizeButtonClick(iFrameResetRequest.isCustomerChat, iFrameResetRequest.showValue, iFrameResetRequest.ClearChatSelection, iFrameResetRequest.isPageLoad, iFrameResetRequest.isIframeOpened)
                    break;
                case 'closeChat':
                    ChatBoxCloseClick();
                    break;
                case 'closeChatClient':
                    HideVagaroConnectChat();
                    break;
                case 'setUnreadCount':
                    setUnreadCount(m.Data);
                    break;
                case 'ExpandMinimizeChatForCustomer':
                    ExpandMinimizeChatForCustomer(m.Data);
                    break;
                case 'iFrameRemoveClass':
                    var RemoveClass = JSON.parse(m.Data);
                    $('#chatFrame').removeClass(RemoveClass.className);
                    break;
                case 'iFrameAddClass':
                    var AddClass = JSON.parse(m.Data);
                    $('#chatFrame').addClass(AddClass.className);
                    break;
                case 'vagaroConnectShowHideLoader':
                    if (typeof window._siteBuilderDetail !== "undefined" && window._siteBuilderDetail !== null && window._siteBuilderDetail.ShowLoaderVagaroConnect !== undefined && window._siteBuilderDetail.ShowLoaderVagaroConnect !== null) {
                        window._siteBuilderDetail.ShowLoaderVagaroConnect(false);
                    }
                    if (typeof (ShowLoader) == 'function') {
                        ShowLoader(false);
                    }
                    break;
                case 'setChatConversationId':
                    window.document.getElementById('hdnChatConversionId').value = m.Data;
                    break;
                case 'openCustomerChatWindow':
                    if (window.document.getElementById('chatWindow') !== null) {
                        $("#chatFrame,#chatWindow").show();
                    }
                    break;
                case 'redirectToPageVagaro':
                    window.location.href = m.Data;
                    break;
                case 'openCustomerProfile':
                    OpenCustomerHistoryPopupFromVagaroConnect(m.Data);
                    break;
                case 'openEmployeeProfile':
                    window.location.href = location.protocol + "//" + location.hostname + (location.port && ":" + location.port) + "/merchants/employee?ConnectSPID=" + m.Data;
                    //OpenEmployeeProfilePopupFromVagaroConnect(m.Data);
                    break;
                case 'OpenTextMessagingPlanPopup':
                    OpenTextMessagingPlanPopup();
                    break;
                case 'ReloadTextMessagingPlanIframe':
                    ReloadTextMessagingPlanIframe();
                    break;
                case 'upDateDetails':
                    _postMessage('{"eventType": "' + m.eventType + '", "payload" : ' + m.Data + '}');
                    break;
                case 'AppoinemtsPopupUpdte':
                    _postMessage('{"eventType": "' + m.eventType + '", "payload" : ' + m.Data + '}');
                    break;
            }
        }
    }
}

function ExpandMinimizeButtonClick(isCustomerChat, showValue, ClearChatSelection = true, isPageLoad = false, isIframeOpened) {

    if (!isCustomerChat && typeof window && window !== undefined && window.document.getElementById('chatFrame') !== undefined && window.document.getElementById('chatFrame') !== null) {
        if (showValue < 0) {
            return;
        } else if (showValue > 3) {
            return;
        } else {
            if ($('.sttingBtns').is(":visible") === true) {
                $('body').addClass('bottom-button-space');
            }
            else {
                $('body').removeClass('bottom-button-space');
            }
            if ($('.editemployee').is(":visible") === true) {
                $('body').addClass('bottom-sticky-chat');
            }


            if ($('.vg-btn-fixrow').is(":visible") === true) {
                $('body').addClass('bottom-button-space');
            }





            if (showValue === 1) {
                $('#chatFrame').addClass('ifream-rightSide');
                $('#chatFrame').removeClass('ifream-smallscreen');
                $('#chatFrame').removeClass('ifream-minimize');
                $('body').removeClass('chat-icon-bottom');
                //CommonMethod.RemoveClassToBody("collapsibleDropDown");
                //CommonMethod.RemoveClassToBody("chatMinimize");

                //for Full Page
                if ($('.ServicesWrap').is(":visible") === true || $('.rmpHiddenView').is(":visible") === true || $('.EmptyCard').is(":visible") === true || $('.marketing-wrapper-inner').is(":visible") === true || $('.page-container').is(":visible") === true) {
                    $('#chatFrame').removeClass('fullpageView');
                }
                //for Full page with Footer
                if ($('.rightServicePart .divRight-Height').is(":visible") === true || $('.inventory-container').is(":visible") === true) {
                    $('#chatFrame').removeClass('fullpageWithFooterView');
                    $('#chatFrame').removeClass('fullpageView');
                } else {
                    $('#chatFrame').removeClass('fullpageWithFooterView');
                    $('#chatFrame').removeClass('fullpageView');
                }
                //for half page with Footer
                if ($('.custom-footerdiv').is(":visible") === true) {
                    $('#chatFrame').removeClass('halfpageWithFooterView');
                }
                if (window.location.pathname === '/ShopOwner/ManageNewServices.aspx') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').removeClass('fullpageWithFooterView');
                    }
                }
                //for half page
                if ($('.settingWrapperHalf').is(":visible") === true || $('.ddsales-settings').is(":visible") === true || $('.settings-body-div').is(":visible") === true || $('.settingMainWarp').is(":visible") === true || $('.vagaroDrive-page').is(":visible") === true) {
                    $('#chatFrame').removeClass('halfpageView');
                    $('#chatFrame').removeClass('fullpageView');
                }
                //Report page
                if (window.location.pathname === '/report/sales/salessummary') {
                    $('#chatFrame').removeClass('fullpageWithFooterViewNoChat');
                }
                //Access lavel page
                if (window.location.pathname === '/merchants/roles') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').removeClass('halfpageWithFooterView');
                    }
                }
                //for calendar page
                if (window.location.pathname === '/merchants/calendar') {
                    $('.liveChat').removeClass('liveChat-calendar');
                    //window.top.$('body').css("overflow", "initial");
                }

                //for checkout page
                if (window.location.pathname === '/ShopOwner/Checkout.aspx') {
                    $('.checkout-right-fix').removeClass('checkoutVC-minimize');
                    $('#chatFrame').removeClass('ifreamCheckOut-minimize');
                }

            } else if (showValue === 2) {
                $('#chatFrame').addClass('ifream-rightSide');
                $('#chatFrame').addClass('ifream-smallscreen');
                $('body').addClass('chat-icon-bottom');
                $('#chatFrame').removeClass('ifream-minimize');
                //CommonMethod.AddClassToBody("collapsibleDropDown");
                //CommonMethod.RemoveClassToBody("chatMinimize");

                //for Full Page
                if ($('.ServicesWrap').is(":visible") === true || $('.rmpHiddenView').is(":visible") === true || $('.EmptyCard').is(":visible") === true || $('.marketing-wrapper-inner').is(":visible") === true || $('.page-container').is(":visible") === true) {
                    $('#chatFrame').removeClass('fullpageView');
                }

                //for Full page with Footer
                if ($('.rightServicePart .divRight-Height').is(":visible") === true || $('.inventory-container').is(":visible") === true) {
                    $('#chatFrame').removeClass('fullpageWithFooterView');
                    $('#chatFrame').removeClass('fullpageView');
                } else {
                    $('#chatFrame').removeClass('fullpageWithFooterView');
                    $('#chatFrame').removeClass('fullpageView');
                }
                //for half page with Footer
                if ($('.custom-footerdiv').is(":visible") === true) {
                    $('#chatFrame').removeClass('halfpageWithFooterView');
                }
                if (window.location.pathname === '/ShopOwner/ManageNewServices.aspx') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').removeClass('fullpageWithFooterView');
                    }
                }
                //for half page
                if ($('.settingWrapperHalf').is(":visible") === true || $('.ddsales-settings').is(":visible") === true || $('.settings-body-div').is(":visible") === true || $('.settingMainWarp').is(":visible") === true || $('.vagaroDrive-page').is(":visible") === true) {
                    $('#chatFrame').removeClass('halfpageView');
                    $('#chatFrame').removeClass('fullpageView');
                }
                //Report page
                if (window.location.pathname === '/report/sales/salessummary') {
                    $('#chatFrame').removeClass('fullpageWithFooterViewNoChat');
                }
                //Access lavel page
                if (window.location.pathname === '/merchants/roles') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').removeClass('halfpageWithFooterView');
                    }
                }
                //for calendar page
                if (window.location.pathname === '/merchants/calendar') {
                    $('.liveChat').addClass('liveChat-calendar');
                    window.top.$('body').css("overflow", "initial");
                }
                //for checkout page
                if (window.location.pathname === '/ShopOwner/Checkout.aspx') {
                    $('.checkout-right-fix').removeClass('checkoutVC-minimize');
                    $('#chatFrame').removeClass('ifreamCheckOut-minimize');
                }
                if (window.MidSizePage) {
                    window.MidSizePage();
                }
            }
            else if (showValue === 3) {
                $('#chatFrame').addClass('ifream-minimize');
                $('body').addClass('chat-icon-bottom');
                //CommonMethod.RemoveClassToBody("collapsibleDropDown");
                //CommonMethod.AddClassToBody("chatMinimize");


                //for Full Page
                if ($('.ServicesWrap').is(":visible") === true || $('.rmpHiddenView').is(":visible") === true || $('.EmptyCard').is(":visible") === true || $('.marketing-wrapper-inner').is(":visible") === true || $('.page-container').is(":visible") === true) {
                    $('#chatFrame').addClass('fullpageView');
                }
                //for Full page with Footer
                if ($('.rightServicePart .divRight-Height').is(":visible") === true || $('.inventory-container').is(":visible") === true) {
                    $('#chatFrame').addClass('fullpageWithFooterView');

                    if ($('#chatFrame').hasClass('fullpageWithFooterView')) {
                        $('#chatFrame').removeClass('halfpageWithFooterView');
                        $('#chatFrame').removeClass('fullpageView');
                    }


                    if ($('.inventory-container').children().length === 0) {
                        $('#chatFrame').addClass('fullpageView');
                        $('#chatFrame').removeClass('fullpageWithFooterView');
                    } else {
                        $('#chatFrame').removeClass('fullpageView');
                        $('#chatFrame').addClass('fullpageWithFooterView');
                    }


                } else {
                    $('#chatFrame').removeClass('fullpageWithFooterView');
                }
                //for half page with Footer
                if ($('.custom-footerdiv').is(":visible") === true) {
                    $('#chatFrame').addClass('halfpageWithFooterView');
                }
                if (window.location.pathname === '/ShopOwner/ManageNewServices.aspx') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').addClass('fullpageWithFooterView');
                        $('#chatFrame').removeClass('fullpageView');
                        $('#chatFrame').removeClass('halfpageWithFooterView');
                    }
                }
                //for half page
                if ($('.settingWrapperHalf').is(":visible") === true || $('.ddsales-settings').is(":visible") === true || $('.settings-body-div').is(":visible") === true || $('.settingMainWarp').is(":visible") === true || $('.vagaroDrive-page').is(":visible") === true) {
                    $('#chatFrame').addClass('halfpageView');

                    if ($('.inventory-container').children().length === 0) {
                        $('#chatFrame').addClass('fullpageView');
                        $('#chatFrame').removeClass('halfpageView');
                    } else {
                        $('#chatFrame').removeClass('fullpageView');
                        $('#chatFrame').addClass('fullpageWithFooterView');
                    }
                }

                //Access lavel page
                if (window.location.pathname === '/merchants/roles') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').addClass('halfpageWithFooterView');
                    } else {
                        $('#chatFrame').removeClass('halfpageWithFooterView');
                    }
                }

                //Report page
                if (window.location.pathname === '/report/sales/salessummary') {
                    if ($('.exportfootSection').is(":visible") === true) {
                        $('#chatFrame').addClass('fullpageWithFooterViewNoChat');
                    } else {
                        $('#chatFrame').removeClass('fullpageWithFooterViewNoChat');
                    }
                }

                //for calendar page
                if (window.location.pathname === '/merchants/calendar') {
                    $('.liveChat').addClass('liveChat-calendar');
                    window.top.$('body').css("overflow", "initial");
                }

                //for checkout page
                if (window.location.pathname === '/ShopOwner/Checkout.aspx') {
                    $('.checkout-right-fix').addClass('checkoutVC-minimize');
                    $('#chatFrame').addClass('ifreamCheckOut-minimize');
                }
                if (window.DownButtonCollapsedPage) {
                    window.DownButtonCollapsedPage();
                }

            }
            else if (showValue === 0) {
                $('#chatFrame').removeClass('ifream-minimize');
                $('#chatFrame').removeClass('ifream-smallscreen');
                $('#chatFrame').removeClass('ifream-rightSide');
                //CommonMethod.RemoveClassToBody("collapsibleDropDown");
                //CommonMethod.RemoveClassToBody("chatMinimize");

                //for Full Page
                if ($('.ServicesWrap').is(":visible") === true || $('.rmpHiddenView').is(":visible") === true || $('.EmptyCard').is(":visible") === true || $('.marketing-wrapper-inner').is(":visible") === true || $('.page-container').is(":visible") === true) {
                    $('#chatFrame').removeClass('fullpageView');
                }
                //for Full page with Footer
                if ($('.rightServicePart .divRight-Height').is(":visible") === true || $('.inventory-container').is(":visible") === true) {
                    $('#chatFrame').removeClass('fullpageWithFooterView');
                    $('#chatFrame').removeClass('fullpageView');
                } else {
                    $('#chatFrame').removeClass('fullpageWithFooterView');
                    $('#chatFrame').removeClass('fullpageView');
                }
                //for half page with Footer
                if ($('.custom-footerdiv').is(":visible") === true) {
                    $('#chatFrame').removeClass('halfpageWithFooterView');
                }
                if (window.location.pathname === '/ShopOwner/ManageNewServices.aspx') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').removeClass('fullpageWithFooterView');
                    }
                }
                //for half page
                if ($('.settingWrapperHalf').is(":visible") === true || $('.ddsales-settings').is(":visible") === true || $('.settings-body-div').is(":visible") === true || $('.settingMainWarp').is(":visible") === true || $('.vagaroDrive-page').is(":visible") === true) {
                    $('#chatFrame').removeClass('halfpageView');
                    $('#chatFrame').removeClass('fullpageView');
                }
                //Access lavel page
                if (window.location.pathname === '/merchants/roles') {
                    if ($('.custom-footerdiv').is(":visible") === true) {
                        $('#chatFrame').removeClass('halfpageWithFooterView');
                    }
                }
                //Report page
                if (window.location.pathname === '/report/sales/salessummary') {
                    $('#chatFrame').removeClass('fullpageWithFooterViewNoChat');
                }
                //for calendar page
                if (window.location.pathname === '/merchants/calendar') {
                    $('.liveChat').removeClass('liveChat-calendar');
                    window.top.$('body').css("overflow", "hidden");
                }
                //for checkout page
                if (window.location.pathname === '/ShopOwner/Checkout.aspx') {
                    $('.checkout-right-fix').removeClass('checkoutVC-minimize');
                    $('#chatFrame').removeClass('ifreamCheckOut-minimize');
                }

            }
        }
        $('body').addClass("vc-open");
    }
    //if (showValue === 2 && ClearChatSelection) {
    //    ChatboadSelection(SelectionControlTypeEnum.None, "", "", "", "", false, false, {});
    //}
    //$("body").addClass("select2Collapsible");
    //setExpandMinimizeShow(showValue);
    //if (showValue === 0 && convertionData.length > 0) {
    //    if (expandMinimizeShow !== showValue) {
    //        setIsNewChat(false);
    //    }
    //    $("body").removeClass("select2Collapsible");
    //    setChatAreaShow(false);
    //}
}
function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function ChatBoxCloseClick(isFromMerChant = false) {
    if (isFromMerChant === false) {
        //DeleteChannel();
        //setExpandMinimizeChatBox(1);
        $('#chatFrame').removeClass('vc-iframeCustomer_extend');
        $('#chatFrame').removeClass('vc-iframeCustomer_minimize');
        $('body').removeClass('chat-icon-bottom');
        window.document.getElementById('chatFrame').style.display = "none";
        $('body').removeClass('VC-customerChatOpen');
        $('meta[name="viewport"]').attr('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0');
        $('body').removeClass("vc-open");

    }
    else if (isFromMerChant === true) {
        //setExpandMinimizeShow(0);
        $('#chatFrame').removeClass('ifream-minimize');
        $('#chatFrame').removeClass('ifream-smallscreen');
        $('#chatFrame').removeClass('ifream-rightSide');
        $('body').removeClass('chat-icon-bottom');
        $('#chatFrame').removeClass('ifream-chatActive');
        window.document.getElementById('chatFrame').style.display = "none";

        //for calendar page
        if (window.location.pathname === '/merchants/calendar') {
            $('.liveChat').removeClass('liveChat-calendar');
            window.top.$('body').css("overflow", "initial");
        }
    }
    if (window.CloseChatButton) {
        window.CloseChatButton()
    }
}
function _postMessage(message) {
    try {
        if ($(_vagaroConnect.controls.chatWindow).length > 0) {
            document.getElementById("chatWindow").contentWindow.postMessage(message, vConnectReactPayload.vagaroConnectWebAppURL);
        }
    }
    catch (e) {
        console.log(e);
    }
}


function checkIframeContent() {
    var iframe = $('#chatWindow')[0]; // Replace 'your-iframe-id' with the ID of your iframe

    // Check if the iframe's contentDocument or contentWindow.document is not null or undefined
    if (iframe && (iframe.contentDocument || iframe.contentWindow.document)) {
        return true;
    } else {
        return false;
    }
}
function setUnreadCount(count) {
    if (parseInt(count) > 0) {
        $('#lblChatCount').html(parseInt(count));
        $('#lblChatCount').show();


    } else {
        $('#lblChatCount').hide();
    }
}

window.BackToFullSizePage = function () {
    _vagaroConnect.SetVcOpenStatus(_vagaroConnect.ChatWindowEnum.FullSize, window.top.location.host + window.top.location.pathname);
};

window.MidSizePage = function () {
    _vagaroConnect.SetVcOpenStatus(_vagaroConnect.ChatWindowEnum.MidSize, window.top.location.host + window.top.location.pathname);
};
window.DownButtonCollapsedPage = function () {
    _vagaroConnect.SetVcOpenStatus(_vagaroConnect.ChatWindowEnum.Minimize, window.top.location.host + window.top.location.pathname);
};
window.CloseChatButton = function () {
    $('body').removeClass('scrollhidden');
    // _vagaroConnect.SetVcOpenStatus(_vagaroConnect.ChatWindowEnum.Closed, window.top.location.host + window.top.location.pathname);
};

function ExpandMinimizeChatForCustomer(steps) {

    if (parseInt(steps) < 0) {
        return;
    } else if (parseInt(steps) > 2) {
        return;
    } else {
        //Logic for iframe Class add
        if (parseInt(steps) === 0) {
            // for minimize chat box
            $('#chatFrame').removeClass('vc-iframeCustomer_extend');
            $('#chatFrame').addClass('vc-iframeCustomer_minimize');
            $('body').removeClass('VC-customerChatOpen');
        } else if (parseInt(steps) === 1) {
            $('#chatFrame').removeClass('vc-iframeCustomer_extend');
            $('#chatFrame').removeClass('vc-iframeCustomer_minimize');
        } else if (parseInt(steps) === 2) {
            //for expand chat box
            $('#chatFrame').addClass('vc-iframeCustomer_extend');
            // window.parent.$('#chatFrame').removeClass('vc-iframeCustomer_minimize');
        }

    }

}

function OpenCustomerHistoryPopupFromVagaroConnect(CustomerId) {

    if (typeof window.top.$CalBookApp.CallCustomerHistoryMain != 'undefined') {
        window.top.$CalBookApp.CallCustomerHistoryMain(CustomerId, 12, "3170442", vConnectReactPayload.ReactBusinessId, "0", "01/29/2024", false, false, false);
    }
    else if (typeof window.top.CallCustomerHistoryMain != 'undefined') {
        window.top.CallCustomerHistoryMain(CustomerId, 12, "3170442", vConnectReactPayload.ReactBusinessId, "0", "01/29/2024", false, false, false);
    }
    window.top.$("#DivCustomerHistoryPopUp").css('z-index', 1000000000)
    window.top.gblIsFromReact = true;

};
function OpenEmployeeProfilePopupFromVagaroConnect(EmployeeId) {
    console.log(EmployeeId);
    window.top.$CalBookApp.CallCustomerHistoryMain(EmployeeId, 12, 0, vConnectReactPayload.ReactBusinessId, "0", "1/12/2021 9:30:00 AM", false, false, false, false, "", null, true, true, null, null)
    window.top.$("#DivCustomerHistoryPopUp").css('z-index', 1000000000)
};

function OpenTextMessagingPlanPopup() {
    var objiframe = $(_vagaroConnect.controls.ifrmTextMarketingPlans);
    var iframeSrc = objiframe.attr('src');
    if (typeof iframeSrc != "undefined" && iframeSrc != null && iframeSrc != "") {
        $(".bootbox-confirm").modal('hide'); // To hide bootbox-confirm box of Limit Exceeded 
        var popupNew = $('#divPromotionTextMarketingPlans');
        popupNew.on('show.bs.modal',
            function () {
                popupNew.addClass("show");
                centerModal(popupNew);
                $('body').addClass('textMessagingModalOpen');
            }).modal("show");
        centerModal(popupNew);
        $("#ifrmTextMarketingPlans").contents().find("#textmarketingplanpopup").animate({
            scrollTop: 0
        }, 'slow');

        popupNew.on('hidden.bs.modal', function (event) {
            $('body').removeClass('textMessagingModalOpen');
        });
    }
    else {
        _vagaroConnect.ShowLoadingPanel(true);
        objiframe.attr('src', _vagaroConnect.model.vagaroConnectTextMessagingPlanIframe);
        objiframe.on('load', function () {
            $(".bootbox-confirm").modal('hide'); // To hide bootbox-confirm box of Limit Exceeded 
            var popupNew = $('#divPromotionTextMarketingPlans');
            popupNew.on('show.bs.modal',
                function () {
                    popupNew.addClass("show");
                    centerModal(popupNew);
                    $('body').addClass('textMessagingModalOpen');
                    _vagaroConnect.ShowLoadingPanel(false);
                }).modal("show");
            centerModal(popupNew);
            $("#ifrmTextMarketingPlans").contents().find("#textmarketingplanpopup").animate({
                scrollTop: 0
            }, 'slow');

            popupNew.on('hidden.bs.modal', function (event) {
                $('body').removeClass('textMessagingModalOpen');
            });
        });
    }
}

function centerModal(obj) {
    if (obj == undefined) {
        obj = this;
    }
    $(obj).css('display', 'block');
    var $dialog = $(obj).not(".in").find(".modal-dialog");
    if ($dialog.length == 0)
        $dialog = $(obj).find(".modal-dialog");

    var selector = window;
    if ($(obj).closest(".modal-dialog").length > 0)
        selector = $(obj).closest(".modal-dialog");
    var height = Math.min($(selector).height(), screen.availHeight);
    if (typeof (window_top) === "undefined" || typeof (window_top) !== "number") window_top = 0;
    var offset = window_top + (height - $dialog.height()) / 2;
    $dialog.css("margin-top", offset);
}

function CloseTextMarketingPopup() {
    if ($("#hdnFromPhoneNumber").val() == "" || $("#aPromotionTextNameAndTotalCount").html() == 'Select Text Marketing Plan') {
        if ($("#HidId").val() == "0") {
            if ($("#HidId").val() == "0" || $("#hdnFromPhoneNumber").val() == "" || $("#aPromotionTextNameAndTotalCount").html() == 'Select Text Marketing Plan') {
                $("#TabEmail").click();
            }
            else {
                $("#btnCancel").click();
            }
        }
    }
}

function ReloadTextMessagingPlanIframe() {
    document.getElementById('ifrmTextMarketingPlans').contentDocument.location.reload(true);
}

function LoadVagaroConnectPlanUsageMeter() {
    _postMessage('{"eventType": "TextMarketingCallBack", "payload" : ""}');
}
function VagaroConnectIframDesignObject() {
    var styleobject = {};
    var gblstyle = $("#dvglbstyle");
    var primarybutton = gblstyle.find("#btnprimarybutton");
    var secondorybutton = gblstyle.find("#btnsecondary");
    var primarybuttonHover = gblstyle.find("#btnprimarybuttonhover");
    var secondorybuttonHover = gblstyle.find("#btnsecondarybuttonhover");
    var lblstyle = gblstyle.find("#txtfontfamily");
    var btnrating = gblstyle.find("#btnrating");
    var glbbackground = gblstyle.find("#glbbackground");
    var glbHeadFonts = gblstyle.find("#glbHeadingFont");
    styleobject.primarybuttoncolor = primarybutton.css("color");
    styleobject.primarybuttonbackgroundcolor = primarybutton.css("background-color");
    styleobject.primarybuttonHoverbackgroundcolor = primarybuttonHover.css("background-color");
    styleobject.primarybuttonborderradius = primarybutton.css("border-radius");
    styleobject.primarybuttonboxshadow = primarybutton.css("box-shadow");
    styleobject.secondorybuttonbuttoncolor = secondorybutton.css("color");
    styleobject.secondorybuttonbuttonbackgroundcolor = secondorybutton.css("background-color");
    styleobject.secondorybuttonbuttonHoverbackgroundcolor = secondorybuttonHover.css("background-color");
    styleobject.secondorybuttonbuttonborderradius = secondorybutton.css("border-radius");
    styleobject.secondorybuttonbuttonboxshadow = secondorybutton.css("box-shadow");
    styleobject.lblstylefontfamily = 'proxima-nova'
    styleobject.lblstylecolor = lblstyle.css("color");
    styleobject.lblstylefontweight = lblstyle.css("font-weight");
    styleobject.lblstylefontsize = lblstyle.css("font-size");
    styleobject.btnratingcolor = btnrating.css("color");
    styleobject.glbbackgroundcolor = glbbackground.css("background-color");
    styleobject.glbHeadingFonts = 'proxima-nova'
    var cookieobject = {};
    cookieobject.vdsid = localStorage.getItem("vdsid");
    //var styledata = { 'eventType': 'addStyle', style: styleobject, 'parentID': 'divbooknowiframe', 'cookieobject': cookieobject }
    setTimeout(() => {
        $(".wbloader").css("display", "none");
        _postMessage('{"eventType": "addStyleVagaroconnect", "payload" : ' + JSON.stringify(styleobject) + '}');
    }, 20);

}

function HideVagaroConnectChat() {
    $('#chatFrame').removeClass('vc-iframeCustomer_extend');
    $('#chatFrame').removeClass('vc-iframeCustomer_minimize');
    $('#chatWindow').attr("src", "");
    $("#chatFrame").hide();
    if (typeof _vagaroConnect != "undefined") {
        _vagaroConnect.model.isChatIframeLoaded = false;
    }
    if (typeof window != 'undefined' && window.document.getElementById('hdnChatConversionId') != null && window.document.getElementById('hdnChatConversionId') != 'undefined') {
        window.document.getElementById('hdnChatConversionId').value = "";
    }
}